var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('rect',{attrs:{"x":"2.3999","y":"1","width":"21.4667","height":"8.05","rx":"2.68333"}}),_c('rect',{attrs:{"x":"2.3999","y":"13.075","width":"21.4667","height":"8.05","rx":"2.68333"}}),_c('path',{attrs:{"d":"M6.4248 5.02502H9.10814","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M6.4248 17.1H9.10814","stroke-linecap":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }